import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

const VoidedModal = ({ onClose, restriction }) => {
    const { subdivision, workEndMp, workStartMp, controlNumber, type,
        freightSpeed, passengerSpeed, tracks, workStartMpSuffix, workEndMpSuffix
    } = restriction || {};

    return (
        <Modal show onHide={onClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Form {type} {controlNumber} has been voided. Please confirm relevant tags have been removed.
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={6}>
                        <p><b>Subdivision: </b> {subdivision}</p>
                        <p><b>From Mp: </b> {workStartMp}{workStartMpSuffix} <b>To Mp: </b> {workEndMp}{workEndMpSuffix}</p>
                        <p><b>Freight Speed: </b> {freightSpeed}</p>
                        <p><b>Passenger Speed: </b> {passengerSpeed}</p>
                    </Col>
                    <Col md={6}>
                        <p>
                            <b>Tracks: </b>
                            {(tracks || []).map(track => <><br />{track.name}</>)}
                        </p>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary" onClick={onClose}>Confirmed </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default VoidedModal;